export default {
      id: "prevSlide-usage",
      viewBox: "0 0 9 14",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#prevSlide-usage",
      toString: function () {
        return this.url;
      }
    }